angular.module('memberPortal').controller('WorkoutsCtrl', ["$scope", "$stateParams", "workouts", function($scope, $stateParams, workouts) {
  $scope.workouts = workouts;
  return $scope.getHash = function() {
    return $stateParams.hash || $stateParams.m;
  };
}]);
